import { fromJS } from 'immutable';
import {
  ACTUALIZE_PACKAGE,
  ACTUALIZE_PACKAGE_SUCCESS,
  ACTUALIZE_PACKAGE_FAIL,
  SHOW_PRICE_CHANGED,
  HIDE_PRICE_CHANGED,
  START_ACTUALIZE_PACKAGE,
  STOP_ACTUALIZE_PACKAGE,
  SET_FRONT_ERROR,
} from '../constants/actualization';

import { CLEAR_PREVIOUS_PACKAGE_DATA } from '../constants/similar-packages';

const initialState = fromJS({
  fetching: false,
  lastUpdated: null,
  error: null,
  success: null,
  rotten: false,
  showPriceChanged: false,
  isActualizationProcess: false,
  exception: null,
  frontError: null,
  show_modal_customer: false,
});

export default function actualizationReducer(state = initialState, action) {
  switch (action.type) {
    case START_ACTUALIZE_PACKAGE:
      return state.set('isActualizationProcess', true);
    case STOP_ACTUALIZE_PACKAGE:
      return state.set('isActualizationProcess', false);
    case ACTUALIZE_PACKAGE:
      return state.set('fetching', true);
    case ACTUALIZE_PACKAGE_SUCCESS: {
      const {
        lastUpdated,
        show_modal_customer,
        data: { rotten, changes, prebook_data, package: pckg },
      } = action.payload;

      const hotelFacts = pckg?.hotel?.facts;

      return state.merge({
        lastUpdated,
        success: true,
        rotten,
        fetching: false,
        changes,
        prebook_data,
        hotelFacts,
        show_modal_customer: show_modal_customer || false,
      });
    }
    case ACTUALIZE_PACKAGE_FAIL: {
      const { lastUpdated, ordered, rotten, exception } = action.payload;
      return state.merge({
        success: false,
        fetching: false,
        lastUpdated,
        ordered,
        rotten,
        exception,
      });
    }
    case SHOW_PRICE_CHANGED:
      return state.set('showPriceChanged', true);
    case HIDE_PRICE_CHANGED:
      return state.set('showPriceChanged', false);
    case CLEAR_PREVIOUS_PACKAGE_DATA:
      return initialState;
    case SET_FRONT_ERROR:
      return state.set('frontError', action.payload);
    default:
      return state;
  }
}
